import { IconFn, IconSvg } from "../createIcon";

export const InfoOutlineIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 42, height: 42 }} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H38C39.933 0.5 41.5 2.067 41.5 4V38C41.5 39.933 39.933 41.5 38 41.5H4C2.067 41.5 0.5 39.933 0.5 38V4ZM4 3.5C3.72386 3.5 3.5 3.72386 3.5 4V38C3.5 38.2761 3.72386 38.5 4 38.5H38C38.2761 38.5 38.5 38.2761 38.5 38V4C38.5 3.72386 38.2761 3.5 38 3.5H4Z"
      fill={color}
    />
    <path d="M23.1547 30.752H19.0013V20.3301H23.1547V30.752Z" fill={color} />
    <path d="M23.1621 16.1621H19.0004V12H23.1621V16.1621Z" fill={color} />
  </IconSvg>
);
